import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";


export class DecodePipe implements PipeTransform {
    transform(text: string): string {
        if (text == null)
            return "";

        var p = document.createElement("textarea");
        p.innerHTML = decodeURIComponent(encodeURIComponent(text));
        text = p.innerText;

        return text;
    }
}


export class DollarFormatPipe implements PipeTransform {
    transform(price: string): string {
        return price.replace(/[$]/g, '<sup class="tsc-sup">$&</sup>');
    }
}


export class EllipsizePipe implements PipeTransform {
    transform(text: string, characterCount: number, ellipsis: string, wordBoundary: boolean): string {
        if (text == null)
            return "";

        if (characterCount < 0 || text.length <= characterCount)
            return text;

        // search beginning of word
        var backup = characterCount;
        while (characterCount > 0 && ('A' <= text[characterCount - 1] && text[characterCount - 1] <= 'Z') || ('a' <= text[characterCount - 1] && text[characterCount - 1] <= 'z')) {
            characterCount--;
        }

        // search previous word
        while (characterCount > 0 && (text[characterCount - 1] == '\r' || text[characterCount - 1] == '\n' || text[characterCount - 1] == '\t' || text[characterCount - 1] == '\f' || text[characterCount - 1] == ' ')) {
            characterCount--;
        }

        // if it was the last word, recover it, unless boundary is requested
        if (characterCount == 0 && !wordBoundary) {
            characterCount = backup;
        }

        var trimmed = text.substring(0, characterCount);
        //return trimmed + ellipsis;

        var p = document.createElement("textarea");
        p.innerHTML = decodeURIComponent(encodeURIComponent(text));
        text = p.innerText;
        
        
        return text;
    }
}

export class ItemNoPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(itemNo: string): string {
        return itemNo.replace(/(\d{3})(\d{3})/, "$1-$2");
    }
static ctorParameters() { return [ { type: DomSanitizer } ]; }}


export class SafePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
static ctorParameters() { return [ { type: DomSanitizer } ]; }}


export class TimeSlotIdFormatPipe implements PipeTransform {
    transform(timeSlot: string): string {
        return timeSlot.replace(/[: ]+/g, "");
    }
}


export class TscCurrencyFormatPipe implements PipeTransform {
    transform(price: string): string {
        if (price) {

            let formatedPrice: string = '';
            let priceArr = price.split('-'); //In case there is a price range
            for (let i = 0; i < priceArr.length; i++) {
                //priceArr[i] = priceArr[i].replace(/[$]/g, '<sup class="tsc-sup">$&</sup>');
                priceArr[i] = priceArr[i].replace('.', '<sup class="tsc-sup">.') + '</sup>';
                //If there is a price range
                if (i) {
                    formatedPrice += '-';
                }
                formatedPrice += priceArr[i];
            }
            return formatedPrice;
        }
    }
}





// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../utility/customPipe.ts